import type { actionType, thanksLinkType } from '@coorum-research/shared-common/types/user-action-histories.type'
import { ulid } from 'ulidx'
import { userActionHistoryApi } from '../apis/user-action-history.api'
import { getResearchSettings } from './user-session-storage.util'

const { createUserActionHistory } = userActionHistoryApi()

type ActionType = typeof actionType[number]
export type ThanksLinkType = typeof thanksLinkType[number]

interface UserActionHistoryParams {
  actionType: ActionType
  popupId?: string
  surveyId?: string
  launcherContentId?: string
  questionId?: string
  popupName?: string
  campaignId?: string
  campaignName?: string
  surveyName?: string
  launcherContentName?: string
  questionName?: string
  thanksLinkType?: ThanksLinkType
  thanksLinkUrl?: string
}

export function recordUserActionHistory({
    actionType,
    popupId,
    surveyId,
    launcherContentId,
    questionId,
    popupName,
    campaignId,
    campaignName,
    surveyName,
    launcherContentName,
    questionName,
    thanksLinkType,
    thanksLinkUrl,
  }: UserActionHistoryParams) {
  const { accountId } = getResearchSettings()

  return createUserActionHistory({
    id: ulid(),
    accountId,
    url: location.href,
    actionType,
    popupId,
    campaignId,
    surveyId,
    launcherContentId,
    questionId,
    detailsJson: {
      popupName,
      campaignName,
      surveyName,
      launcherContentName,
      questionName,
      thanksLinkType,
      thanksLinkUrl,
    },
  })
}
